import axios from 'axios';
import {
  DEFAULT_PLATFORM_BROWSE_MODE,
  normalizePlatformBrowseMode,
  type PlatformBrowseMode,
} from '@/constants/platformBrowseMode';
import { error } from '@/utils/logger';

const API_URL = process.env.NEXT_PUBLIC_APP_API_BASE_URL;

export const PUBLIC_PLATFORM_CONFIG = `${API_URL}/api/v1/public/platform-config`;

export interface PublicPlatformConfigResponse {
  browse_mode: PlatformBrowseMode;
  updated_at?: string | null;
}

export async function getPublicPlatformConfig(options?: {
  signal?: AbortSignal;
}): Promise<PublicPlatformConfigResponse> {
  try {
    const response = await axios.get(PUBLIC_PLATFORM_CONFIG, {
      signal: options?.signal,
    });
    const payload = (response.data?.data ?? response.data) as Record<string, unknown> | null;
    const browseMode = normalizePlatformBrowseMode(
      payload?.browse_mode ?? DEFAULT_PLATFORM_BROWSE_MODE
    );
    const updatedAt =
      typeof payload?.updated_at === 'string' ? payload.updated_at : null;
    return {
      browse_mode: browseMode,
      updated_at: updatedAt,
    };
  } catch (err) {
    error('[getPublicPlatformConfig] Error fetching public platform config:', err);
    throw err;
  }
}
